<button
  mat-icon-button
  [matTooltip]="T_SCOPE + '.export-to-image' | translate | lowercase"
  (click)="exportToImage()"
>
  <mat-icon class="material-icons-outlined" svgIcon="export-to-image"></mat-icon>
</button>
